// extracted by mini-css-extract-plugin
export default {"ModeratorListItem":"beg_a big_a big_r big_j","ModeratorListItem__left":"beg_b big_a big_j"};